import React, { Component } from "react";
import Layout from "../Layout";

const vehicle = window.current_vehicle ?? null;

class FormPlaceADeposit extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { ...rest } = this.props;
        const title = this.props.additionalData.title
            ? this.props.additionalData.title
            : "Place a deposit";
        const text = this.props.additionalData.intro
            ? this.props.additionalData.intro
            : "Secure this vehicle now with our online deposit system. Safe, easy and fully refundable.";
        const terms = this.props.additionalData.terms;

        const name = vehicle["@LISTING_TITLE"];
        const number_plate = vehicle["@LISTING_PLATE"];
        const spec = vehicle["@LISTING_ENGINE"];
        const miles = vehicle["@LISTING_ODOMETER_DISPLAY"];
        const info = `${vehicle["@LISTING_ENGINE"]}, ${vehicle["@LISTING_FUEL_TYPE"]}, ${vehicle["@LISTING_TRANSMISSION"]}`;
        const src = `https://data.autoplay.co.nz/image.ashx?id=${vehicle["@LISTING_IMAGE_SEQ"]}`;

        return (
            <Layout title={title} text={text} terms={terms} {...rest}>
                <div className="popup-form__vehicle">
                    <div
                        className="popup-form__vehicle-image"
                        style={{ backgroundImage: `url(${src})` }}
                    ></div>
                    <div className="popup-form__vehicle-content">
                        <div className="popup-form__vehicle-name">{name}</div>
                        <div className="popup-form__vehicle-spec">{spec}</div>
                        <div className="popup-form__vehicle-info">
                            {miles}
                            <br />
                            {info}
                        </div>
                        <div className="popup-form__vehicle-plate">
                            Number plate: {number_plate}
                        </div>
                    </div>
                </div>
                <div className="gravity-form-content"></div>
            </Layout>
        );
    }
}

export default FormPlaceADeposit;
